export const siteRoles = [
  { label: 'Admin', value: 'admin' },
  { label: 'Trusted user', value: 'trusted-user' },
  { label: 'Reviewer', value: 'reviewer' },
  { label: 'Limited reviewer', value: 'limited-reviewer' },
  { label: 'Transcriber', value: 'transcriber' },
  { label: 'Limited transcriber', value: 'limited-transcriber' },
  { label: 'Viewer', value: 'viewer' },
  { label: 'Editor', value: 'editor' },
];

export const globalRoles = [
  { label: 'Global admin', value: 'global_admin' },
  { label: 'Site admin', value: 'site_admin' },
  { label: 'Editor', value: 'editor' }, // @todo remove?
  { label: 'Reviewer', value: 'reviewer' }, // @todo remove?
  { label: 'Author', value: 'author' }, // @todo remove?
  { label: 'Researcher', value: 'researcher' }, // @todo remove?
  { label: 'Transcriber', value: 'Transcriber' }, // @todo lowercase.
  // @todo add viewer / standard user
];
